import { http, HttpResponse } from "msw";
import { PlessService } from "../../../app/shared/pless-service.model";

let count = 0;

export const kymw0907Handlers = [
  http.post(PlessService.SERVICE.getNvalDetailId.url, async ({ request }) => {
    const req = await request.json();
    count = count + 1;
    if (count === 1) {
      return HttpResponse.json(getNvalDetailIdResponse);
    } else if (count === 2) {
      return HttpResponse.json(getNvalDetailIdResponse1);
    } else if (count === 3) {
      return HttpResponse.json(getNvalDetailIdResponse2);
    } else if (count === 4) {
      return HttpResponse.json(getNvalDetailIdResponse3);
    }
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
]

const getNvalDetailIdResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      NvalDetailId: "76128"
    }
  }
}

const getNvalDetailIdResponse1 = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      NvalDetailId: "76129"
    }
  }
}

const getNvalDetailIdResponse2 = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      NvalDetailId: "76130"
    }
  }
}

const getNvalDetailIdResponse3 = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      NvalDetailId: "76131"
    }
  }
}